<template>
    <section class="c-pager o-page-row" v-if="typeof Pagination.Pages !== 'undefined' && Pagination.Pages.length > 1">
                <span v-if="pageInfo" class="u-color-muted">
                    {{ Pagination.PageStartIndex }} - {{ Pagination.PageEndIndex }} {{ $t('global.of') }} {{ Pagination.TotalCount }}
                </span>
                <span v-else></span>
        <nav class="c-pager-nav">
            <ul class="c-pager-menu">
                <li v-if="Pagination.PageLastIndex > 10">
                    <button type="button" class="c-button--reset c-pager-item c-pager-item--first" @click.prevent="paginateToPage('first')">
                        <svgicon class="svg-left" name="arrow-rounded" width="5.5" height="5"></svgicon>
                        <svgicon class="svg-left" name="arrow-rounded" width="5.5" height="5"></svgicon>
                        <span class="u-font-tiny">{{ $t('global.first')  }}</span>
                    </button>
                </li>
                <li>
                    <button type="button" class="c-button--reset c-pager-item c-pager-item--previous" @click.prevent="paginateToPage('previous')">
                        <svgicon class="svg-left" name="arrow-rounded" width="5.5" height="5"></svgicon>
                        <span class="u-font-tiny">{{ $t('global.previous')  }}</span>
                    </button>
                </li>

                <li v-for="page in Pagination.Pages" :key="page">
                    <button type="button" class="c-button--reset c-pager-item"
                       :class="{'is-active': page === config.Page }"
                       @click.prevent="paginateToPage(page)">{{ page }}</button>
                </li>

                <li>
                    <button type="button" class="c-button--reset c-pager-item c-pager-item--next" @click.prevent="paginateToPage('next')">
                        <span class="u-font-tiny">{{ $t('global.next')  }}</span>
                        <svgicon class="svg-right" name="arrow-rounded" width="5.5" height="5"></svgicon>
                    </button>
                </li>
                <li v-if="Pagination.PageLastIndex > 10">
                    <button type="button" class="c-button--reset c-pager-item c-pager-item--last" @click.prevent="paginateToPage('last')">
                        <span class="u-font-tiny">{{ $t('global.last')  }}</span>
                        <svgicon class="svg-right" name="arrow-rounded" width="5.5" height="5"></svgicon>
                        <svgicon class="svg-right" name="arrow-rounded" width="5.5" height="5"></svgicon>
                    </button>
                </li>
            </ul>
        </nav>
      <slot name="page-size"></slot>
    </section>
</template>

<script>
    export default {
        props: {
          config: {},
          pagination: {},
          pageInfo: {
            type: Boolean,
            default: true
          },
        },
        data() {
            return {
                data: this.pagination
            }
        },
        computed: {
            Pagination() {let params = this.pagination;
                return {
                    ...params
                }
            }
        },
        methods: {
            paginateToPage(page) {
                // Set new config page
                page = page === 'first' ? 1: page;
                page = page === 'last' ? this.Pagination.PageLastIndex: page;
                page = page === 'previous' ? this.config.Page - 1: page;
                page = page === 'next' ? this.config.Page + 1: page;

                // Prev & Next do nothing when first or last
                if (page === 0 || page > this.Pagination.PageCount) { return }
                this.config.Page = page;
                this.$emit('paginated', this.config);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue